import { I18n } from "@/i18n/I18n";
import { ForbiddenError, NotFoundError, ValidationError } from "./customErrorTypes";
import { FusaReply } from "@/types/replyTypes";

export interface FusaError {
  message: string;
  details?: string
  hideToast?: boolean;
  link?: string;
  linkText?: string;
}

export function createFusaError(
  error: any, 
  overrides?: Partial<FusaError>
): FusaError {
  return {
    message: error instanceof Error ? error.message : I18n.get('unknownError'),
    ...overrides
  };
}

export function getErrorStatus(error: any, defaultStatus: number = 500): number {
  if (error instanceof NotFoundError) {
    return 404;
  }
  if (error instanceof ForbiddenError) {
    return 403;
  }
  if (error instanceof ValidationError) {
    return 422;
  }
  return defaultStatus;
}

export async function createFusaErrorFromResponse(response: Response): Promise<FusaReply> {
  try {
    return await response.json();
  } catch {
    return {
      status: response.status,
      errors: [
        {
          // statusText is empty over HTTP/2, so fall back to a real message
          // rather than showing an empty error to the user.
          message: response.statusText || I18n.get('unknownError'),
        }
      ]
    };
  }
}